import * as C from './consts';
import { boundApiReducer as api } from 'redux-upgrader';

export const validateToken = api(
    C.VALIDATE_TOKEN,
    Object
);